import { useLocaleContext } from '@src/components/locale/locale.context'
import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'
import { parseLocale } from '@src/utils/i18n.utils'

export default function useEddExp(): {
  isEddExpEnabled: boolean
  experimentBucket: string
  isInitialized: boolean
} {
  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.EDD)

  // disable EDD for ca
  const { locale } = useLocaleContext()
  const country = parseLocale(locale).country?.toLowerCase()

  return {
    isEddExpEnabled:
      experimentBucket !== STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.EDD].buckets?.control &&
      country !== 'ca' &&
      init,
    experimentBucket: experimentBucket ?? '',
    isInitialized: init,
  }
}
